import { format } from "date-fns";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCommentDots,
} from "@fortawesome/free-solid-svg-icons";
import "../Investigation/remarksAndDocumentsModal.scss";
import { Table } from "react-bootstrap";
import TextTruncate from "../../../../utilsComponent/textTruncate";

const RemarksAndDocumentsModal = ({
  remarks = [],
  closingRemarks = [],
  documents = [],
  title,
  onDocumentClick,
  roleDataCookie
}) => {
  const handleDocumentClick = (docs) => {
    if (onDocumentClick) {      
      onDocumentClick(docs);
    }
  };

  const getDocumentsForRemark = (referenceId) => {    
    if (!referenceId) return [];    
    return documents.filter(doc => doc.referenceId === referenceId);
  };

  return (
    <div className="row w-100">
      <div className="remarks-section p-4 mx-4 border rounded shadow-sm">
        {/* Header */}
        <div className="d-flex align-items-center mb-3">
          <h5 className="mb-0">{title}</h5>
        </div>

        {/* Remarks Section */}
        <h6 className="text-secondary mb-3">
          <FontAwesomeIcon icon={faCommentDots} className="me-2" />
          Remarks
        </h6>
        {remarks.length > 0 ? (
          <div className="table-responsive mb-4">
            <Table striped bordered hover size="sm">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Updated By</th>
                  <th>Remarks</th>
                  <th>Date & Time</th>
                  <th>Documents</th>
                </tr>
              </thead>
              <tbody>
                {remarks.map((remark, idx) => {
                  const matchedDocs = getDocumentsForRemark(remark.referenceId);
                  console.log('matched docs', matchedDocs);
                  
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{remark.updatedBy || "--"}</td>
                      <td><TextTruncate text={remark.remarks} length={30}/></td>
                      <td>{format(new Date(remark.timestamp), "dd-MM-yyyy hh:mm a")}</td>
                      <td>
                        {matchedDocs.length > 0 ? (
                          <button
                            type="button"
                            className="btn btn-link text-primary p-0"
                            onClick={() => handleDocumentClick(matchedDocs)}
                          >
                            View Documents ({matchedDocs.length})
                          </button>
                        ) : (
                          <span className="text-muted">---</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <p className="text-muted fst-italic">No remarks available.</p>
        )}

        {/* Closing Remarks Section */}
        <h6 className="text-secondary mb-3">
          <FontAwesomeIcon icon={faCommentDots} className="me-2" />
          Closing Remarks
        </h6>
        {closingRemarks.length > 0 ? (
          <div className="table-responsive mb-4">
            <Table striped bordered hover size="sm">
              <thead className="table-light">
                <tr>
                  <th>#</th>
                  <th>Updated By</th>
                  <th>Remarks</th>
                  <th>Date & Time</th>
                  <th>Documents</th>
                </tr>
              </thead>
              <tbody>
                {closingRemarks.map((remark, idx) => {
                  const matchedDocs = getDocumentsForRemark(remark.referenceId);
                  return (
                    <tr key={idx}>
                      <td>{idx + 1}</td>
                      <td>{remark.updatedBy || "--"}</td>
                      <td><TextTruncate text={remark.remarks} length={30} /></td>
                      <td>{format(new Date(remark.timestamp), "dd-MM-yyyy hh:mm a")}</td>
                      <td>
                        {matchedDocs.length > 0 ? (
                          <button
                            type="button"
                            className="btn btn-link text-primary p-0"
                            onClick={() => handleDocumentClick(matchedDocs)}
                          >
                            View Documents ({matchedDocs.length})
                          </button>
                        ) : (
                          <span className="text-muted">---</span>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          </div>
        ) : (
          <p className="text-muted fst-italic">No closing remarks provided.</p>
        )}
      </div>
    </div>
  );
};

export default RemarksAndDocumentsModal;